<div class='ontario-header__container'>
  <header class='ontario-application-header ontario-header' id='ontario-header'>
    <div class='ontario-row'>
      <div class='ontario-columns ontario-small-6 ontario-application-header__logo'>
        <a tabindex="1" title="{{ 'bss.header.govon' | translate }}" href="{{ 'bss.header.govon.logo.link' | translate }}">
          <img src='assets/logos/ontario-logo--desktop.svg' class="ontario-show-for-medium" alt="{{ 'bss.header.govon' | translate }}" role='img' />
          <img src='assets/logos/ontario-logo--mobile.svg' class="ontario-show-for-small-only" alt="{{ 'bss.header.govon' | translate }}" width="45" height="46">
        </a>
      </div>
      <div class='ontario-columns ontario-small-6 ontario-application-header__lang-toggle'>
        <div id="langContainer">
          <a tabindex="2" title="{{ 'bss.header.en.title' | translate }}" *ngIf="!isCurrentEn" (click)="onSwitchLang()" (keyup.enter)="onSwitchLang()" class='ontario-header__language-toggler ontario-header-button ontario-header-button--without-outline ontario-show-for-small-only'>En</a>
          <a tabindex="3" title="{{ 'bss.header.en.title' | translate }}" *ngIf="!isCurrentEn" (click)="onSwitchLang()" (keyup.enter)="onSwitchLang()" class='ontario-header__language-toggler ontario-header-button ontario-header-button--without-outline ontario-show-for-medium'>English</a>
          <a tabindex="4" title="{{ 'bss.header.fr.title' | translate }}" *ngIf="isCurrentEn" (click)="onSwitchLang()" (keyup.enter)="onSwitchLang()" class='ontario-header__language-toggler ontario-header-button ontario-header-button--without-outline ontario-show-for-small-only'>Fr</a>
          <a tabindex="5" title="{{ 'bss.header.fr.title' | translate }}" *ngIf="isCurrentEn" (click)="onSwitchLang()" (keyup.enter)="onSwitchLang()" class='ontario-header__language-toggler ontario-header-button ontario-header-button--without-outline ontario-show-for-medium'>Français</a>
        </div>
      </div>
    </div>
  </header>
  <div class='ontario-application-subheader-menu__container'>
    <section class='ontario-application-subheader'>
      <div class='ontario-row'>
        <div class='ontario-columns ontario-small-12 ontario-application-subheader__container'>
          <p class='ontario-application-subheader__heading'>
             <a tabindex="6" title="{{ 'bss.title.description' | translate }}" routerLink="/public/login">{{ 'bss.title' | translate }}</a>
          </p>
          <div class='ontario-application-subheader__menu-container' id="menuContainer">
            <button
              tabindex="7" 
              title="{{ 'bss.header.menu.title' | translate }}"
              class='ontario-header__menu-toggler ontario-header-button ontario-header-button--with-outline'
              id='ontario-header-menu-toggler'
              aria-controls='ontario-navigation'
              aria-label='open menu'
              type='button'>
              <svg class='ontario-icon' focusable='false' viewBox='0 0 24 24' preserveAspectRatio='xMidYMid meet'>
                 <use xlink:href='#ontario-icon-menu'></use>
              </svg>
              <span>{{ 'bss.header.menu' | translate }}</span>
            </button>
            <button
              tabindex="8" 
              title="{{ 'bss.header.menu.title' | translate }}"
              class="ontario-header__menu-toggler ontario-header-button ontario-header-button--with-outline"
              id="ontario-header-nav-toggler"
              aria-controls="ontario-navigation"
              aria-label="close">
              <svg
                 class="ontario-icon" focusable="false" viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                 <use xlink:href="#ontario-icon-close"></use>
              </svg>
              <span>{{ 'bss.header.menu' | translate }}</span>
            </button>
          </div>
        </div>
      </div>
    </section>
    <nav class="ontario-navigation" id="ontario-navigation">
      <div class="ontario-navigation__container">
        <ul>
          <li id="menuitem_services" [style.display]="menuService.getMenuItemServicesDisplayStatus()"><a tabindex="9" title="{{ 'bss.header.menu.myServices.title' | translate }}" routerLink="/secure/myservices">{{ 'bss.header.menu.myServices' | translate }}</a></li>
          <li id="menuitem_login" [style.display]="menuService.getMenuItemLoginDisplayStatus()"><a tabindex="10" title="{{ 'bss.header.menu.login.title' | translate }}" routerLink="/public/login">{{ 'bss.header.menu.login' | translate }}</a></li>
          <li id="menuitem_profile" [style.display]="menuService.getMenuItemProfileDisplayStatus()"><a tabindex="11" title="{{ 'bss.header.menu.profile.title' | translate }}" routerLink="/secure/profile">{{ 'bss.header.menu.profile' | translate }}</a></li>
          <li id="menuitem_roles" [style.display]="menuService.getMenuItemRolesDisplayStatus()"><a tabindex="12" title="{{ 'bss.header.menu.roles.title' | translate }}" routerLink="secure/user/roles">{{ 'bss.header.menu.roles' | translate }}</a></li>
          <li id="menuitem_admin" [style.display]="menuService.getMenuItemAdminDisplayStatus()"><a tabindex="13" title="{{ 'bss.header.menu.admin.title' | translate }}" (click)="menuService.redirectAdminLink()">{{ 'bss.header.menu.admin' | translate }}</a></li>
          <li id="menuitem_logout" [style.display]="menuService.getMenuItemLogoutDisplayStatus()"><a tabindex="14" title="{{ 'bss.header.menu.logout.title' | translate }}" routerLink="/public/logout">{{ 'bss.header.menu.logout' | translate }}</a></li>
          <li id="menuitem_help" [style.display]="menuService.getMenuItemHelpDisplayStatus()"><a tabindex="15" title="{{ 'bss.header.menu.help.title' | translate }}" routerLink="/public/help" (click)="onHelp()" (keyup.enter)="onHelp()">{{ 'bss.header.menu.help' | translate }}</a></li>
        </ul>
      </div>
    </nav>
  </div>

  <div *ngIf="!isProduction">
    <div class='ontario-row'>
      <div class="ontario-columns ontario-small-12 center-row-container">
        <span style="color: #FF0000; padding-top: 10px;" [innerHTML]="'bss.header.nonProdWarning' | translate"></span>
      </div>
    </div>
  </div>

</div>
<div class='ontario-overlay'></div>

<main aria-labelledby="pageTitle">
  <router-outlet></router-outlet>
</main>

<footer class="ontario-footer ontario-footer--default">
  <div class="ontario-row">
    <div class="ontario-columns ontario-small-12">
      <ul class="ontario-footer__links-container ontario-footer__links-container--inline">
        <li>
          <a tabindex="901" target="_blank" class="ontario-footer__link" title="{{ 'bss.footer.accessibility.title' | translate }}" href="{{ 'bss.footer.accessibility.link' | translate }}">
            {{ 'bss.footer.accessibility' | translate }}<svg class="ontario-icon" alt="" aria-hidden="true" focusable="false" sol:category="primary" viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet"><use href="#ontario-icon-new-window"></use></svg>
          </a>
        </li>
        <li>
          <a tabindex="902" target="_blank" class="ontario-footer__link" title="{{ 'bss.footer.privacy.title' | translate }}" href="{{ 'bss.footer.privacy.link' | translate }}">
            {{ 'bss.footer.privacy' | translate }}<svg class="ontario-icon" alt="" aria-hidden="true" focusable="false" sol:category="primary" viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet"><use href="#ontario-icon-new-window"></use></svg>
          </a>
        </li>
        <li>
          <a tabindex="903" class="ontario-footer__link" title="{{ 'bss.footer.contactus.title' | translate }}" (click)="myDialog.showModal();openContactUsPopup($event)" href="#">
            {{ 'bss.footer.contactus' | translate}}
          </a></li>
        <li>
          <a tabindex="904" class="ontario-footer__link" title="{{ 'bss.footer.help.title' | translate }}" (click)="onHelp()" (keyup.enter)="onHelp()">
            {{'bss.footer.help' | translate }}
          </a>
        </li>
      </ul>
      
      <dialog class="ontario-popup ontario-popup-contactus" #myDialog>
        <div class="ontario-row">
          <div class="ontario-popup-closerow">
            <img tabindex="151" src='assets/logos/ontario-logo--popup.png' class="ontario-popup--logo"
              alt='Government of Ontario' title="{{'bss.footer.contactus.popup.ontarioGovLogo' | translate }}"
              role='img' />
            <button tabindex="152" class=" ontario-popup-closerow-button"
              title="{{'bss.footer.contactus.button.closePopup'|translate}}" (click)="myDialog.close()">
              &times;
            </button>
          </div>

        </div>
        <div class="ontario-row">
          <h2 class="ontario-popup-closerow-title">{{'bss.footer.contactus.popup.title'|
            translate}}</h2>
        </div>
        <div class="ontario-row">
          <h4>{{'bss.footer.contactus.popup.subTitle'| translate}}</h4>
          <hr style="margin-top: 0px; margin-bottom: 10px;">
        </div>
        <div class="ontario-row" [style.display]="contactService.getLandingContentDisplayStatus()" 
          [innerHTML]="'bss.footer.contactus.popup.content.landingContent' | translate"></div>
        <div class="ontario-row" [style.display]="contactService.getOpsBpsContentDisplayStatus()"
          [innerHTML]="'bss.footer.contactus.popup.content.opsBpsContent' | translate"></div>
      </dialog>

      <div class="ontario-footer__copyright">
        <a tabindex="905" target="_blank" class="ontario-footer__link" title="{{ 'bss.footer.kingsPrinter.title' | translate }}" href="{{ 'bss.footer.kingsPrinter.link' | translate }}">{{ 'bss.footer.kingsPrinter' | translate }},
          <span class="ontario-nbsp">2012–25</span><svg class="ontario-icon" alt="" aria-hidden="true" focusable="false" sol:category="primary" viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet"><use href="#ontario-icon-new-window"></use></svg>
        </a>
      </div>
    </div>
  </div>
</footer>
